import type { AssessmentReportSourceSnapshotV2 } from '../reports/assessmentReportDomain';
import InitialAssessmentResultRenderer from '../renderers/InitialAssessmentResultRenderer';

interface AssessmentClinicalSourcesPanelProps {
  sources: readonly AssessmentReportSourceSnapshotV2[];
  collapsible?: boolean;
}

const formatDate = (value: string): string => {
  const calendarDate = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (calendarDate) return `${calendarDate[3]}/${calendarDate[2]}/${calendarDate[1]}`;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? 'Data não informada' : parsed.toLocaleDateString('pt-BR');
};

/** Preserva a história e o exame da ficha-fonte, além do resumo dos testes. */
export default function AssessmentClinicalSourcesPanel({
  sources,
  collapsible = false,
}: AssessmentClinicalSourcesPanelProps) {
  const clinicalSources = sources.filter((source) => source.snapshot.clinicalAssessment);
  if (!clinicalSources.length) return null;

  return (
    <section className="space-y-4" aria-label="História, exame e plano incluídos no documento">
      {clinicalSources.map((source) => {
        const heading = `${source.snapshot.testLabel} · ${formatDate(source.snapshot.assessmentDate)}`;
        const content = <InitialAssessmentResultRenderer payload={source.snapshot.clinicalAssessment} />;

        return collapsible ? (
          <details key={source.resultId} className="rounded-2xl border border-slate-200 bg-white p-4">
            <summary className="cursor-pointer text-sm font-bold text-slate-900">
              História, exame e plano: {heading}
            </summary>
            <p className="mt-2 text-xs text-slate-500">
              Conteúdo preservado da avaliação selecionada. Para corrigir o registro clínico, edite a avaliação de origem e revise sua seleção neste documento.
            </p>
            <div className="mt-4">{content}</div>
          </details>
        ) : (
          <div key={source.resultId} className="space-y-3">
            <h2 className="text-base font-bold text-slate-950">História, exame e plano · {heading}</h2>
            {content}
          </div>
        );
      })}
    </section>
  );
}
